import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white py-12" data-id="element-60">
      <div className="container mx-auto px-4" data-id="element-61">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-62">
          <div className="lg:col-span-1" data-id="element-63">
            <div className="text-2xl font-bold bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent mb-4" data-id="element-64">
              JoinOmu
            </div>
            <p className="text-gray-600 dark:text-gray-400 mb-6" data-id="element-65">
              Connecting patients to personalized treatment plans through
              dedicated healthcare providers and our innovative digital
              platform.
            </p>
          </div>
          <div data-id="element-66">
            <h3 className="font-semibold text-lg mb-4" data-id="element-67">Treatment Areas</h3>
            <ul className="space-y-2" data-id="element-68">
              <li data-id="element-69">
                <Link to="/weight-loss" onClick={scrollToTop} className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors" data-id="element-70">
                  Weight Loss
                </Link>
              </li>
              <li data-id="element-71">
                <Link to="/mens-health" onClick={scrollToTop} className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors" data-id="element-72">
                  Hormone Therapy
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-73">
            <h3 className="font-semibold text-lg mb-4" data-id="element-74">Coming Soon</h3>
            <ul className="space-y-2" data-id="element-75">
              <li data-id="element-76">
                <span className="text-gray-400 dark:text-gray-500 cursor-not-allowed flex items-center" data-id="element-77">
                  Counseling
                  <span className="ml-2 text-xs bg-gray-200 dark:bg-gray-700 px-2 py-0.5 rounded" data-id="element-78">
                    Soon
                  </span>
                </span>
              </li>
              <li data-id="element-79">
                <span className="text-gray-400 dark:text-gray-500 cursor-not-allowed flex items-center" data-id="element-80">
                  Peptides
                  <span className="ml-2 text-xs bg-gray-200 dark:bg-gray-700 px-2 py-0.5 rounded" data-id="element-81">
                    Soon
                  </span>
                </span>
              </li>
              <li data-id="element-82">
                <span className="text-gray-400 dark:text-gray-500 cursor-not-allowed flex items-center" data-id="element-83">
                  Vitality
                  <span className="ml-2 text-xs bg-gray-200 dark:bg-gray-700 px-2 py-0.5 rounded" data-id="element-84">
                    Soon
                  </span>
                </span>
              </li>
              <li data-id="element-85">
                <span className="text-gray-400 dark:text-gray-500 cursor-not-allowed flex items-center" data-id="element-86">
                  Skin Care
                  <span className="ml-2 text-xs bg-gray-200 dark:bg-gray-700 px-2 py-0.5 rounded" data-id="element-87">
                    Soon
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <div data-id="element-88">
            <h3 className="font-semibold text-lg mb-4" data-id="element-89">Company</h3>
            <ul className="space-y-3" data-id="element-90">
              <li data-id="element-91">
                <a href="https://www.indeed.com/viewjob?jk=da22fcc0bd6a38ab&from=shareddesktop_copy" target="_blank" rel="noopener noreferrer" className="text-gray-600 dark:text-gray-300 hover:text-[#BBDDFF] dark:hover:text-[#BBDDFF] transition-colors" data-id="element-92">
                  For Providers
                </a>
              </li>
              <li data-id="element-93">
                <Link to="/investors" onClick={scrollToTop} className="text-gray-600 dark:text-gray-300 hover:text-[#BBDDFF] dark:hover:text-[#BBDDFF] transition-colors" data-id="element-94">
                  For Investors
                </Link>
              </li>
              <li data-id="element-95">
                <a href="https://www.indeed.com/viewjob?jk=da22fcc0bd6a38ab&from=shareddesktop_copy" target="_blank" rel="noopener noreferrer" className="text-gray-600 dark:text-gray-300 hover:text-[#BBDDFF] dark:hover:text-[#BBDDFF] transition-colors" data-id="element-96">
                  Careers
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 dark:border-gray-800 mt-12 pt-8" data-id="element-97">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-98">
            <div className="flex items-center mb-4 md:mb-0" data-id="element-99">
              <svg className="w-5 h-5 text-[#BBDDFF] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-100">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-101" />
              </svg>
              <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-102">
                HIPAA Compliant & Secure
              </span>
            </div>
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6" data-id="element-103">
              <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-104">
                {new Date().getFullYear()} JoinOmu, Inc. All rights reserved.
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}